import {useMemo} from "react";
import {useRoomConfig} from "../RoomConfigContext";
import {useSeatConfig} from "../SeatConfigContext";
import {getMaximumOffset} from "../utils/speakerUtils";
import {getOppositeLength} from "../utils/trig";

// ceiling speakers don't use the regular constraint / validation ruleset. Instead, their positions are entirely
// calculated before validation
export const useRearSpeakers = (numSpeakers, rearInCeiling, wallConfig, ceilingConfig, builtInWall) => {
    const {width, height, depth} = useRoomConfig();
    const {primaryEarPosition, numRows, rowHeight} = useSeatConfig();

    return useMemo(() => {
        // no back speakers for 5.1
        if (numSpeakers === 5) return [];
        // use the diagonal as the minimum offset to walls
        const size = rearInCeiling ? ceilingConfig.size : wallConfig.size;
        const maxW = builtInWall ? size[2] * .4 : getMaximumOffset(size) * 0.75;
        const maxX = builtInWall ? width * .5 - size[1] : width * .5 - maxW;
        const z = depth - maxW;
        const distToSeat = z - -primaryEarPosition[2];
        let x = getOppositeLength(distToSeat, 180 - 142.5);
        x = Math.min(maxX, x);

        let y = height;
        if (!rearInCeiling) {

            //const ceiling = getCeilingHeight(x + size[0] * .5, roofHeight, width, freeHeight);
            //const maxY = ceiling - wallConfig.size[1];

            // center the speakers at 120cm
            y = 120 + (numRows - 1) * rowHeight - wallConfig.size[1] * .5;

            // unless there's not headroom --> Don't mind the headroom, there is a minimum height.
            /*if (y > maxY) {
                y = maxY;
            }*/
        }
        const angle = builtInWall ? 0 : -Math.atan2(x, distToSeat);

        return [
            {
                position: [x, y, -z],
                rotation: angle
            },
            {
                position: [-x, y, -z],
                rotation: -angle
            }
        ];
    }, [width, height, depth, primaryEarPosition, numSpeakers, wallConfig, ceilingConfig, rearInCeiling, numRows, rowHeight, builtInWall]);
}
